type BufferLike = {
  byteLength(data: string): number
  from(data: string): { toString(encoding: 'base64'): string }
}

type GlobalWithBuffer = typeof globalThis & {
  Buffer?: BufferLike
}

function getBuffer(): BufferLike | undefined {
  return (globalThis as GlobalWithBuffer).Buffer
}

export function getStringByteLength(data: string): number | undefined {
  return getBuffer()?.byteLength(data)
}

export function toBase64(data: string): string {
  const buffer = getBuffer()
  if (buffer) {
    return buffer.from(data).toString('base64')
  }
  return btoa(data)
}

/**
 * 对对象名按 `/` 分段做 URL 编码（保留路径分隔符）。
 *
 * 用于把 Bucket 内相对路径安全地拼进 URL path，避免空格、`#`、`?`、`%`、中文等字符
 * 破坏或截断 URL（query 段已单独编码，此处仅处理 path 段）。仅对每段做 `encodeURIComponent`，
 * 不编码分隔符 `/`，与 supabase-js 的处理方式一致。
 *
 * @param cleanName 已由 `cleanPath` 规整过的相对路径（无首尾斜杠、无重复斜杠）。
 */
export function encodeObjectName(cleanName: string): string {
  return cleanName
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/')
}
